import { render, staticRenderFns } from "./MyImageUpload.vue?vue&type=template&id=6811952d&scoped=true"
import script from "./MyImageUpload.vue?vue&type=script&lang=js"
export * from "./MyImageUpload.vue?vue&type=script&lang=js"
import style0 from "./MyImageUpload.vue?vue&type=style&index=0&id=6811952d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6811952d",
  null
  
)

export default component.exports